import { RecurlyPayment } from 'api'
import { Recurly, RecurlyErrorResponse, Token } from 'lib/recurly/types'
import { Mixpanel, MIXPANEL_PROPS } from 'utils/mixpanel'
import { translate } from 'utils/translation'

import { THREE_D_ELEMENT_ID } from '../components/form/consts'

interface HandleThreeDSecureParams {
  removeObserver: () => void
  token: RecurlyPayment
  mixpanelProps: Record<string, unknown>
  addObserver: () => void
  recurly: Recurly
  error: RecurlyErrorResponse
  setShowThreeDAuth: (val: boolean) => void
  setIsLoading: (val: boolean) => void
  setServerError: ({ type, message }: { type: string; message: string }) => void
  checkoutSuccessSource: string
  handleRequest: ({
    token,
    threeDSecureToken,
    skipPreCheckout,
    checkoutSuccessSource,
  }: {
    token: RecurlyPayment
    threeDSecureToken: string
    skipPreCheckout: boolean
    checkoutSuccessSource: string
  }) => void
}

export const handleThreeDSecure = ({
  recurly,
  error,
  removeObserver,
  token,
  mixpanelProps,
  addObserver,
  setShowThreeDAuth,
  setIsLoading,
  setServerError,
  handleRequest,
  checkoutSuccessSource,
}: HandleThreeDSecureParams) => {
  const container = document.getElementById(THREE_D_ELEMENT_ID)
  if (!container) return
  container.replaceChildren()
  setShowThreeDAuth(true)

  const { code, description } = error.response.data

  const risk = recurly.Risk()
  const threeDSecure = risk.ThreeDSecure({
    actionTokenId: description?.three_d_secure_action_token_id || '',
  })

  threeDSecure.on('token', (threeDToken: Token) => {
    removeObserver()
    setShowThreeDAuth(false)

    handleRequest({
      token,
      threeDSecureToken: threeDToken.id,
      skipPreCheckout:
        !error.response.request.responseURL.includes('pre_checkout'),
      checkoutSuccessSource,
    })
  })

  threeDSecure.on(
    'error',
    (threeDError: { code?: string; message?: string }) => {
      removeObserver()
      setShowThreeDAuth(false)
      setServerError({
        type: 'error',
        message: translate('three_d_verification_failed'),
      })
      // @ts-ignore TODO: Wait for TS component update
      Mixpanel.trackPaymentSubmitClick({
        ...(mixpanelProps || {}),
        paymentStatus: MIXPANEL_PROPS.PAYMENT_STATUS.values.PAYMENT_ISSUE,
        paymentIssue: `${threeDError?.code || code}: ${
          threeDError?.message || translate('three_d_verification_failed')
        }`,
        code: threeDError?.code || code,
        message: threeDError?.message,
      })
      setIsLoading(false)
    },
  )

  addObserver()

  const element = document.getElementById(THREE_D_ELEMENT_ID)
  if (!element) return
  threeDSecure.attach(element)
  return null
}
